// IDENTIDAD DE LA SESIÓN (V1) — nombre y rol REALES de la cuenta autenticada, junto a la cabecera
// existente del Radar. No se escribe a mano, no se deduce un turno y no se reduce a iniciales: el
// nombre completo siempre es accesible (visible desde sm, y por título/detalle en móvil).
import { useState } from "react";
import { useAuth } from "@/context/AuthContext";

const ROL_LABEL = {
  supervisor: "Supervisor",
  monitorista: "Monitorista",
  institucional_admin: "Administrador institucional",
  institucional_operador: "Monitorista institucional",
};

const iniciales = (texto) => (texto || "?").trim().split(/\s+/).slice(0, 2)
  .map((p) => p.charAt(0).toUpperCase()).join("");

// Nombre CORTO para móvil: primer nombre + inicial del siguiente apellido. El completo nunca se
// pierde: se despliega al tocar.
const nombreCorto = (nombre) => {
  const partes = (nombre || "").trim().split(/\s+/).filter(Boolean);
  if (partes.length <= 1) return partes[0] || "";
  return `${partes[0]} ${partes[1].charAt(0)}.`;
};

export default function SesionIdentidad({ testId = "radar-sesion-identidad" }) {
  const { user } = useAuth();
  const [abierto, setAbierto] = useState(false);
  const nombre = user?.nombre || user?.email || "Sesión";
  const rol = ROL_LABEL[user?.role] || "Operación";

  return (
    <div className="relative shrink-0">
      <button type="button" data-testid={testId} onClick={() => setAbierto((v) => !v)}
        aria-expanded={abierto}
        title={`${nombre} — ${rol}`}
        className="flex min-h-10 max-w-[15rem] items-center gap-2 rounded-xl px-1.5 py-1 text-left transition-colors hover:bg-slate-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#01CBE3]">
        <span aria-hidden="true"
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#012472]/10 text-[11px] font-extrabold tracking-tight text-[#012472]">
          {iniciales(nombre)}
        </span>
        <span className="min-w-0 leading-tight">
          <span data-testid="radar-sesion-nombre" className="block truncate text-[13px] font-bold text-slate-800">
            {/* Una sola lectura para el lector de pantalla: la variante oculta por breakpoint va
                marcada aria-hidden, así el nombre no se enuncia dos veces. */}
            <span aria-hidden="true" className="sm:hidden">{nombreCorto(nombre)}</span>
            <span className="hidden sm:inline">{nombre}</span>
            <span className="sr-only sm:hidden">{nombre}</span>
          </span>
          <span data-testid="radar-sesion-rol" className="block truncate text-[11px] font-semibold text-slate-500">{rol}</span>
        </span>
      </button>
      {abierto && (
        <div data-testid="radar-sesion-detalle"
          className="absolute right-0 z-30 mt-1 w-64 rounded-xl border border-slate-200 bg-white p-3 text-left shadow-lg">
          <p className="text-sm font-bold text-slate-800">{nombre}</p>
          <p className="mt-0.5 text-xs font-semibold text-slate-500">{rol}</p>
          {user?.email && <p className="mt-1 truncate text-[11px] text-slate-400">{user.email}</p>}
          <p className="mt-2 text-[11px] leading-snug text-slate-400">
            Sesión autenticada. El Radar observa; la atención del caso ocurre en Central.
          </p>
        </div>
      )}
    </div>
  );
}
